import React from 'react';
import PropTypes from 'prop-types';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import TextFormatter from 'utils/TextFormatter';

class CloseCodeRadioGroup extends React.Component {

    constructor(props) {
        super(props);
        this.handleChecked = this
            .handleChecked
            .bind(this);
    }

    handleChecked(e, type) {
        const { closeCode, workOrderActions, user, orderId } = this.props;

        workOrderActions.closeCodeAdd({
            primaryCode: closeCode.get('code'),
            secondaryCode: type === 'secondary' ? e.target.value : null,
            username: user.get('userId')
        }, orderId);
    }

    getSecondaryCodesCheckboxList() {
        const { closeCode, checked, disabled } = this.props;
        const secondaryCloseCodes = closeCode.get("secondaryCodes");

        if (closeCode && secondaryCloseCodes && checked) {
            return secondaryCloseCodes.map((code, index) => {
                return <RadioButton
                    key={"secondaryRadioButton" + index}
                    disabled={disabled}
                    value={code.get('code')}
                    label={code.get('description')}
                    style={{
                        display: 'inline-block',
                        paddingTop: '8%'
                    }}
                />
            });
        }
        return null;
    }

    render() {
        const { closeCode, checked, selectedCloseCodeList, disabled } = this.props;
        const secondaryCloseCodes = closeCode.get("secondaryCodes");

        const radioButton = (
            <RadioButton
                key={"primaryCloseCode" + closeCode.get('code')}
                disabled={disabled}
                onClick={() => this.handleChecked(closeCode.get('code'), "primary")}
                value={closeCode.get('code')}
                checked={checked}
                style={{
                    float: 'left', paddingTop: "5%"
                }}
                label={TextFormatter.humanizeTitle(closeCode.get('description'))} />
        );

        const selectedSecondaryCode = selectedCloseCodeList ? selectedCloseCodeList.find((existingCode) =>
            secondaryCloseCodes.some(code => existingCode.get('code') === code.get('code'))) : null;

        const closeCodesRadioGroup = <RadioButtonGroup
            style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '16%'
            }}
            onChange={(e) => this.handleChecked(e, "secondary")}
            name="SecondaryCloseCodes"
            valueSelected={selectedSecondaryCode ? selectedSecondaryCode.get('code') : null}>
            {this.getSecondaryCodesCheckboxList()}
        </RadioButtonGroup>;

        return (<div style={{ paddingLeft: '16px' }}>
            {radioButton}
            {closeCodesRadioGroup}
        </div>);

    }
}

CloseCodeRadioGroup.propTypes = {
    closeCode: PropTypes.object,
    checked: PropTypes.bool,
    workOrderActions: PropTypes.object,
    orderId: PropTypes.string,
    user: PropTypes.object,
    billingSystem: PropTypes.string,
    disabled: PropTypes.bool
};

export default CloseCodeRadioGroup;


// WEBPACK FOOTER //
// ./src/components/close-code/CloseCodeRadioGroup.js